module.exports = __webpack_public_path__ + "static/media/Outcome.a562258d.png";